import { MatToolbarModule } from '@angular/material/toolbar';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { PageHeadingComponent } from './page-heading.cmp';
import { PageHeadingService } from './page-heading.svc';

@NgModule({
    imports: [RouterModule,MatToolbarModule],
    exports: [PageHeadingComponent],
    declarations: [PageHeadingComponent],
    providers: [PageHeadingService],
})
export class PageHeadingModule { }
